(function () {
  'use strict';

  const nav      = document.getElementById('dc-nav');
  const megaWrap = document.getElementById('mega-wrap');
  if (!nav || !megaWrap) return;

  /* ── Sticky offset — measure the real announcement+nav height so anything
     sticking below it (e.g. the collection filter bar) lines up exactly,
     instead of relying on a guessed pixel constant ── */
  function updateStickyOffset() {
    const ann = document.querySelector('.dc-ann');
    const annHeight = ann ? ann.offsetHeight : 0;
    const navInner = nav.querySelector('.dc-nav__inner');
    const navHeight = navInner ? navInner.offsetHeight : nav.offsetHeight;
    document.documentElement.style.setProperty('--dc-ann-height', annHeight + 'px');
    document.documentElement.style.setProperty('--dc-sticky-offset', (annHeight + navHeight) + 'px');
  }
  updateStickyOffset();
  if (!nav.dataset.stickyInit) {
    nav.dataset.stickyInit = '1';
    if ('ResizeObserver' in window) {
      new ResizeObserver(updateStickyOffset).observe(nav);
    } else {
      window.addEventListener('resize', updateStickyOffset);
    }
  }

  /* ── Shrink-on-scroll (compact nav) ────────────────────────────
     Past a small threshold, toggle a class that compacts the nav
     (less padding, smaller logo — see CSS). The ResizeObserver
     above already keeps --dc-sticky-offset in sync whenever this
     changes the nav's rendered height, so no extra work needed
     here beyond the class toggle itself. rAF-throttled to avoid
     layout thrashing from rapid scroll events.

     The on/off thresholds are deliberately far apart. #header-group
     sits in normal flow, so compacting shortens the document by the
     nav's height delta (72px → 58px desktop, 72px → 54px mobile).
     The browser compensates for that — scroll anchoring, or clamping
     near the end of the page — by shifting scrollY by the same
     amount. With one shared threshold that shift pushes scrollY back
     across it, un-compacting the nav, which shifts scrollY back
     again: the header vibrates up and down forever, with no input
     from the visitor. Keeping the thresholds further apart than the
     largest delta (18px) leaves both states stable.                */
  const COMPACT_ON  = 64;
  const COMPACT_OFF = 24;
  let compactTicking = false;
  let isCompact = false;

  function applyCompactState() {
    compactTicking = false;
    const y = window.scrollY;
    const shouldCompact = isCompact ? y > COMPACT_OFF : y > COMPACT_ON;
    if (shouldCompact === isCompact) return;
    isCompact = shouldCompact;
    nav.classList.toggle('dc-nav--compact', isCompact);
  }

  function onScroll() {
    if (compactTicking) return;
    compactTicking = true;
    requestAnimationFrame(applyCompactState);
  }

  applyCompactState();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ── Mega menus ──────────────────────────────────────────────── */
  const megas = {
    shop:   { item: document.getElementById('nav-item-shop'),   link: document.getElementById('nav-link-shop'),   panel: document.getElementById('mega-shop')   },
    brands: { item: document.getElementById('nav-item-brands'), link: document.getElementById('nav-link-brands'), panel: document.getElementById('mega-brands') }
  };

  let openKey    = null;
  let closeTimer = null;

  function openMega(key) {
    clearTimeout(closeTimer);
    if (openKey === key) return;
    Object.values(megas).forEach(m => {
      m.panel.classList.remove('open');
      m.item.classList.remove('open');
      m.link.setAttribute('aria-expanded', 'false');
    });
    openKey = key;
    megas[key].panel.classList.add('open');
    megas[key].item.classList.add('open');
    megas[key].link.setAttribute('aria-expanded', 'true');
    megaWrap.style.pointerEvents = 'auto';
    closeAcct();
    closeSearch();
  }

  function closeMegas(immediate) {
    clearTimeout(closeTimer);
    const doClose = () => {
      Object.values(megas).forEach(m => {
        m.panel.classList.remove('open');
        m.item.classList.remove('open');
        m.link.setAttribute('aria-expanded', 'false');
      });
      openKey = null;
      megaWrap.style.pointerEvents = 'none';
    };
    immediate ? doClose() : (closeTimer = setTimeout(doClose, 140));
  }

  /* ── Search expand ───────────────────────────────────────────── */
  const searchBtn    = document.getElementById('nav-search-btn');
  const searchExpand = document.getElementById('nav-search-expand');
  const searchInput  = document.getElementById('nav-search-input');
  const searchClose  = document.getElementById('nav-search-close');
  const logo         = document.getElementById('nav-logo');

  function openSearch() {
    closeMegas(true);
    if (logo) logo.classList.add('dc-nav__logo--hidden');
    if (searchExpand) searchExpand.style.display = 'flex';
    if (searchBtn) searchBtn.classList.add('active');
    setTimeout(() => searchInput?.focus(), 80);
  }

  function closeSearch() {
    if (logo) logo.classList.remove('dc-nav__logo--hidden');
    if (searchExpand) searchExpand.style.display = 'none';
    if (searchBtn) searchBtn?.classList.remove('active');
    if (searchInput) searchInput.value = '';
  }

  /* ── Account coordination ────────────────────────────────────── */
  function closeAcct() {
    const wrap = document.getElementById('acct-wrap');
    if (!wrap) return;
    document.getElementById('acct-popover-guest')?.setAttribute('hidden', '');
    document.getElementById('acct-popover-user')?.setAttribute('hidden', '');
    wrap.classList.remove('open');
    document.getElementById('acct-btn')?.setAttribute('aria-expanded', 'false');
  }

  /* ── Mobile drawer ───────────────────────────────────────────── */
  const hamburger     = document.getElementById('nav-hamburger');
  const mobileDrawer  = document.getElementById('mobile-drawer');
  const mobileOverlay = document.getElementById('mobile-overlay');
  const drawerClose   = document.getElementById('drawer-close');

  function openDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.add('open');
    mobileDrawer.setAttribute('aria-hidden', 'false');
    mobileOverlay?.classList.add('open');
    hamburger?.setAttribute('aria-expanded', 'true');
    hamburger?.classList.add('open');
    document.body.style.overflow = 'hidden';
    closeMegas(true);
    closeSearch();
  }

  function closeDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.remove('open');
    mobileOverlay?.classList.remove('open');
    hamburger?.setAttribute('aria-expanded', 'false');
    hamburger?.classList.remove('open');
    document.body.style.overflow = '';
    setTimeout(() => { mobileDrawer.setAttribute('aria-hidden', 'true'); }, 320);
  }

  /* ── Mega menu events ────────────────────────────────────────── */
  Object.entries(megas).forEach(([key, m]) => {
    m.link.addEventListener('mouseenter', () => { if (searchExpand?.style.display === 'flex') return; openMega(key); });
    m.link.addEventListener('click', () => { closeMegas(true); }); // navigate to href, close any open mega
    m.item.addEventListener('mouseleave', () => closeMegas(false));
  });

  megaWrap.addEventListener('mouseenter', () => clearTimeout(closeTimer));
  megaWrap.addEventListener('mouseleave', () => closeMegas(false));

  document.addEventListener('click', e => { if (!nav.contains(e.target)) closeMegas(true); });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeMegas(true); closeSearch(); closeDrawer(); }
  });

  /* ── Search events ───────────────────────────────────────────── */
  searchBtn?.addEventListener('click', e => { e.stopPropagation(); openSearch(); });
  searchClose?.addEventListener('click', e => { e.stopPropagation(); closeSearch(); });
  searchInput?.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeSearch();
  });

  // Block empty submissions; non-empty lets the form navigate to /search?q=…
  document.getElementById('nav-search-expand')?.addEventListener('submit', e => {
    if (!searchInput?.value.trim()) e.preventDefault();
  });

  /* ── Drawer events ───────────────────────────────────────────── */
  hamburger?.addEventListener('click', e => { e.stopPropagation(); openDrawer(); });
  drawerClose?.addEventListener('click', closeDrawer);
  mobileOverlay?.addEventListener('click', closeDrawer);

  /* ── Drawer accordions ───────────────────────────────────────── */
  document.querySelectorAll('.dc-drawer-link--toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const sub = document.getElementById(btn.dataset.target);
      if (!sub) return;
      const isOpen = sub.classList.contains('open');
      document.querySelectorAll('.dc-drawer-sub.open').forEach(s => s.classList.remove('open'));
      document.querySelectorAll('.dc-drawer-link--toggle.open').forEach(b => {
        b.classList.remove('open');
        b.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        sub.classList.add('open');
        btn.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

})();
